module.exports = __webpack_public_path__ + "img/shouzhi.7963cd02.gif";